import StageDefault from './StageDefault';

export default StageDefault;
